import api from "service/axios.service";
import {
  SOBREPOSICOES_FAIL,
  SOBREPOSICOES_REQUEST,
  SOBREPOSICOES_SUCCESS,
} from "../constants/sobreposicoesConstants";

export const sobreposicoesData = (choice) => async (dispatch) => {
  const { type, territorialCut, territory } = choice || {};
  const { value: valueCut } = territorialCut || {};
  const { label, value } = territory || {};

  dispatch({ type: SOBREPOSICOES_REQUEST });
  try {
    const newValueCut =
      valueCut === "rural_properties" || valueCut === "traditional_territories"
        ? "municipality"
        : valueCut;

    const res = await api.post(`/v2/overlapTerritory/${newValueCut}/`, {
      codTerritory: type,
      nameTerritory: [label],
      geocodes: [value],
    });

    const { data } = res || {};
    const [values] = data || [];

    dispatch({
      type: SOBREPOSICOES_SUCCESS,
      payload: values || {},
    });
  } catch (error) {
    dispatch({
      type: SOBREPOSICOES_FAIL,
      payload: error.response?.data.message
        ? error.message.data.message
        : error.message,
    });
  }
};
